import { render } from "./puzzlePiece.vue?vue&type=template&id=7500ddf3&scoped=true"
import script from "./puzzlePiece.vue?vue&type=script&lang=ts"
export * from "./puzzlePiece.vue?vue&type=script&lang=ts"

import "./puzzlePiece.vue?vue&type=style&index=0&id=7500ddf3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7500ddf3"

export default script